<template>
   <modal :size="'md'" @close="$emit('close')">
      <div slot="body" >
         <div class="row"
             v-for="bet in ticket.bets"
             :key="'modal-ticket-bet-'+bet.id"
         >
            <div class="col-12 col-md-6"
                v-for="(chunk, index) in chunk(fieldsSet, 5)"
                :key="'sp-gr-'+bet.id+'-'+index"
            >

               <div class="list-group">
                  <div
                      class="list-group-item list-group-item-action flex-column align-items-start"
                      v-for="pathObj in chunk"
                      :key="'sp-gr-'+bet.id+'-'+snakeCase(pathObj.tag)"
                  >
                     <div class="d-flex w-100 justify-content-between">
                        <h6 class="mb-1">
                           <t :tag="'user.page.table.sportbets.'+pathObj.tag"></t>
                        </h6>
                     </div>
                     <p class="mb-1" v-html="getValue(pathObj, {ticket, bet})">

                     </p>
                  </div>
               </div>

            </div>
           <div class="col-12">
              <hr>
           </div>
         </div>
      </div>
   </modal>
</template>

<script>
import Modal from '@/components/parts/modal';



function getTag(field) {
   const t = field.split('.');
   return t[t.length -1];
}
function pathConstructor(path){
   let defaultObj = {
      field: '*',
      tag: null,
      handler: (val)=> val
   }
   let result = {};



   if(typeof path === 'string'){


      Object.assign(result, defaultObj, {
         field: path,
         tag: getTag(path),
         handler: (val)=> val
      });
   } else if(typeof path === 'object' && path.hasOwnProperty('field')){

      Object.assign(result, defaultObj, {
         field: path.field,
      });
      if( path.hasOwnProperty('handler') && typeof path.handler === 'function'){
         Object.assign(result,{
            handler: path.handler,
         });
      }
      if( path.hasOwnProperty('tag')){
         Object.assign(result, {
            tag: path.tag,
         });
      }else{
         Object.assign(result, {
            tag: getTag(path.field),
         });
      }
   }




   return result;
}

export default {
   name: "SportModal",
   components:{
      Modal
   },
   props:{
      ticket:Object
   },
   data(){return{
      /*fieldsBase: [
         'ticket.ticket_id',
         'bet.created',
         'bet.sport_name',
         'bet.match_name',
         'bet.bet_name',
         {
            field: 'ticket.amount',
            handler: (val)=> this.formatToMoney(parseFloat(val)*100)
         },
         {
            field: 'ticket.maxamount',
            handler: (val)=> this.formatToMoney(parseFloat(val)*100)
         },
         {
            field: 'ticket.stake',
            handler: (val)=> this.formatToMoney(parseFloat(val)*100)
         },
          'bet.status',
          'bet.matchBetOutcomeId',
          'bet.odd_value',
         {
            field: 'bet.cancel',
            handler: ()=> ''

         }
      ]*/
   }},
   computed:{
      fieldsSet(){
         return [

            {
               field: 'ticket.ticket_id',
               tag: 'ticket_id',
               handler: (val,self)=> `<b>${val}</b>`
            },
            /*'bet.created',*/
            'bet.match_name',

             'ticket.product',
            'bet.sport_name',

            //'bet.bet_name',
             'ticket.ticket_type',
            {
               field: 'bet.status',
               tag: 'status',
               handler: (val,self)=> `<b>${ self.t('user.page.table.sportbets.status.'+val)}</b>`
            },
             'bet.bet_name',
            {
               field: 'ticket.stake_amount',
               tag: 'amount',
               handler: (val,self)=> self.formatToMoney(self.safeNumber(val))
            },
            /*{
               field: 'ticket.winning_max_amount',
               tag: 'maxamount',
               handler: (val,self)=> self.formatToMoney(self.safeNumber(val))
            },*/
            /*{
               field: 'ticket.winning_amount',
                tag: 'stake',
               handler: (val, self)=> self.formatToMoney(self.safeNumber(val))
            },*/
            'bet.betOutcome_name',
            {
               field: 'bet.odd_value',
               tag: 'odd_value'
            },
            /*{
               field: 'bet.cancel',
               handler: ()=> ''

            }*/
         ].map(pathConstructor);
      }

   },

   mounted(){

   },
   methods:{
      betDateString(date){
         date = moment(date);

         let format = this.isSimple ? 'DD/MM' : 'DD/MM/YYYY';
         let br = this.isSimple ? '<br>' : '';

         return `${date.format(format)}
				${br}
				${this.formatToTime(date)}`;
      },
      isCancelAvailable(bet){
         return false; //TODO:
      },



      getPathTranslationTag(field){
         const t = field.split('.');
         return t[t.length -1];
      },
      getValue(path, object){

         return path.handler(_.get(object, path.field, ''), this);
      },
      chunk(array, length){
         return _.chunk(array, length)
      }
   }
}
</script>

<style scoped>

</style>
